function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#345D9D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.0412 42.325L45.1646 31.7923L50.0315 30.4121L51.0484 26.9255L46.2542 28.3782L51.339 11.0901V10.8141C51.3352 10.7034 51.3097 10.5946 51.2638 10.4938C51.218 10.393 51.1527 10.3022 51.0718 10.2266C50.9908 10.1511 50.8958 10.0922 50.792 10.0534C50.6883 10.0146 50.578 9.99664 50.4673 10.0005H44.0024C43.7577 9.99298 43.5174 10.0675 43.32 10.2123C43.1225 10.3571 42.9792 10.5639 42.9128 10.7996L36.8838 31.2838L32.0896 32.7366L31 36.078L35.7942 34.6252L31.5085 49.2257H57.0775C57.3228 49.2358 57.5643 49.1623 57.7623 49.0171C57.9603 48.8719 58.103 48.6637 58.1671 48.4267L59.6198 43.4146V43.1385C59.6161 43.0279 59.5906 42.919 59.5447 42.8182C59.4989 42.7174 59.4336 42.6266 59.3526 42.5511C59.2717 42.4755 59.1766 42.4166 59.0729 42.3779C58.9692 42.3391 58.8588 42.3211 58.7482 42.325H42.0412Z",
  fill: "white"
});

var SvgLtc = function SvgLtc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LTC.c6778727.svg";
export { ForwardRef as ReactComponent };